import { EVENT_NAMES } from 'services/analytics/eventNames';
import { trackEvent } from 'services/analytics/trackEvent';
import type { TGroupType } from 'services/analytics/types';

type Props = {
  group_id?: string | null;
  group_type: TGroupType;
  click_action: 'start_group' | 'create_group' | 'edit_group' | 'update_group';
};

export const trackGroupConfigAction = ({
  group_id = null,
  group_type,
  click_action,
}: Props) => {
  trackEvent(EVENT_NAMES.GROUP_CONFIG_ACTION, {
    group_id,
    group_type,
    click_action,
  });
};
